import { Input, Directive, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

//@Directive({
//    selector: '[disableControl]'
//})
//export class DisableControlDirective {

//    @Input() set disableControl(condition: boolean) {
//        const action = condition ? 'disable' : 'enable';
//        if (this.ngControl.control) {
//            if (condition) {
//                this.ngControl.control.disable();
//            }
//            else {
//                this.ngControl.control.enable();
//            }
//            //            this.ngControl.control[action]();
//        }
//    }

//    constructor(private ngControl: NgControl) {
//    }

//}
@Directive({
    selector: '[disableControl]',
    standalone: false
})
export class DisableControlDirective implements OnChanges {
    @Input() disableControl = false;

    constructor(private ngControl: NgControl) { }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['disableControl'] && this.ngControl.control) {
            const action = this.disableControl ? 'disable' : 'enable';
            this.ngControl.control[action]();
        }
    }
}

